import { Component, inject } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';
import { IconsComponent } from '../icons/icon.component';
import { ToastService } from '@core/services/local/toast.service';
import { NgbToastModule } from '@ng-bootstrap/ng-bootstrap';
import { bootstrapXLg } from '@ng-icons/bootstrap-icons';

@Component({
  imports: [TranslateModule, IconsComponent, NgbToastModule],
  standalone: true,
  selector: 'toast-component',
  templateUrl: './toast.component.html',
  host: {
    class: 'toast-container position-fixed bottom-0 p-3',
    style: 'z-index: 1200; left: 50%; transform: translateX(-50%); ',
  },
})
export class ToastComponent {
  private _toastService = inject(ToastService);

  protected toasts = this._toastService.toasts;

  protected icon = bootstrapXLg;

  closeToast(ref: string) {
    this._toastService.remove(ref);
  }
}
